<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="preface">
<h1 style="text-align: right;">Preface</h1>
<p style="text-indent:0px;">Recent growth in the field of diagnostic radiology has dramatically increased the complexity of this field. Diagnostic imaging has become widely available and plays an increasing role in clinical diagnosis and therapy. However, in most practices, miscommunication between radiologists and other physicians occurs frequently mainly because physicians often are not completely familiar with the role of radiology in patient care.</p>
<p style="text-indent:0px;">Maybe we have an obsession for cases, but when we were resident in radiology, we loved to learn especially from cases, not only because they are short, exciting, and fun similar to a detective story in which the aim is to get to “the bottom” of the case, but also because, in the end, that’s what radiologists are faced with during their daily work.</p>
<p style="text-indent:0px;">The topics covered in the book represent the common and important diseases encountered in abdominal and pelvic imaging. The material presented for each case provides a thorough and comprehensive description of the disease entity enabling the radiologist or the clinician to develop a clear concept of the entity through the different imaging modalities that are present. We hope that will be useful for residents in radiology, radiologists and physicians.</p>
<p style="text-indent:0px;">What is interesting in this book is one case per page. The book can be used as a mean of rapid revision of a large number of cases in a short time or as a test of knowledge by masking the radiological description and diagnosis and trying by using the clinical data and radiological images to describe first, the pathology, then propose a diagnosis.</p>
<br/>
<p style="text-align: right;">Ammar Haouimi <br/>Rabah Bouguelaa</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?1b4e3e0d